<div *ngIf="showMe">
    <tds-modal show="true" (tdsClose)="closeDialog(false)" header="Dispensation for Assignment nr: {{assignmentNumber}}" size="sm">
        <span slot="body">
            <div *ngIf="!hasDispensation">
                <span style="text-align: justify;"> Do you want to give dispensation for this assignment to be ongoing for longer then allowed?</span>
            </div>
            <div *ngIf="hasDispensation">
                <span style="text-align: justify;"> This assignment has dispensation to be ongoing for longer then allowed. Do you want to remove the dispensation?</span>
            </div>
        </span>

        <span slot="actions">
            <tds-button
                type="button"
                variant="secondary"
                size="md"
                text="No"
                [disabled]="isSaving"
                (click)="closeDialog(false)">
            </tds-button>

            <tds-button style="margin-left: 15px;"
                type="button"
                variant="primary"
                size="md"
                text="Yes"
                [disabled]="isSaving"
                (click)="closeDialog(true)">
            </tds-button>
        </span>
    </tds-modal>
</div>
